import hamburger from './components/hamburger'
import slider from './components/slider'
import map from './components/map'
import gallery from './components/gallery'

document.addEventListener("DOMContentLoaded", () => {
    document.querySelector('.offscreen-nav').removeAttribute('style');
    hamburger();
    slider();
    map();
    gallery();
});

